// TODO: Add tests
export function getLabelKebabCase(strings: string[]): string {
    const kebabCaseStrings: string[] = [];
    strings.forEach((s: string) => {
        // Remove extra white space, make all letters lower case, and replace space(s) with dashes
        kebabCaseStrings.push(s.trim().toLowerCase().replace(/\s+/g, '-'));
    });
    return kebabCaseStrings.join('-').replace(/[-]+/g, '-');
}
